/**
 * STAY_KIND wire enum + schema — SCRUM-334 (DS-020 §5).
 *
 * Wire source of truth for the StayKind axis on the reservation list +
 * detail DTOs. Must be set-equal to the domain `STAY_KIND_VALUES` catalog in
 * `apps/api/src/modules/booking/domain/quote/value-objects/stay-kind.vo.ts`.
 * The I3 drift-gate spec enforces equality at build time (step 1b):
 *   apps/api/src/modules/booking/application/reservation/__tests__/stay-kind-drift-gate.spec.ts
 *
 * Mirrors the HEARD_ABOUT_WIRE_VALUES precedent in
 * `packages/validators/src/booking/reservation-lifecycle.schema.ts`.
 */
import { z } from 'zod';
/**
 * Wire enum for the StayKind axis. Must be set-equal to the domain
 * `STAY_KIND_VALUES` catalog. The drift-gate test enforces equality at
 * build time.
 */
export const STAY_KIND_WIRE_VALUES = [
    'PayingGuest',
    'OwnerStay',
    'NonStayBlock',
];
/** Wire schema for the StayKind axis (closed z.enum of STAY_KIND_WIRE_VALUES). */
export const stayKindSchema = z.enum(STAY_KIND_WIRE_VALUES);
//# sourceMappingURL=stay-kind.schema.js.map